export {};

declare global {
  interface Array<T> {
    getListIds(): string[];
  }

  interface ArrayConstructor {
    fromObjectOrIdList<T>(data: (string | (T & { _id: string }))[], model: new (modelData: any) => T): (string | T)[];
  }
}

Array.prototype.getListIds = function () {
  return this.map(item => (typeof item === 'string' ? item : item._id));
};

Array.fromObjectOrIdList = (data, model) => data.map(d => (typeof d === 'string' ? d : new model(d)));
